import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

// ADR-027: measurement-bearing pages (dashboard, health overview, alerts) are
// HQ-admin only — the backend 403s site_admin. A site_admin who bookmarks or
// types one of these URLs is silently redirected to /employees (their landing
// page) rather than shown a broken page or an "access denied" flash.
//
// Mirrors RequireAuth's loading handling: render nothing while the auth check
// is in flight so we don't bounce a still-loading admin.
export function RequireAdminRole({ children }: { children: React.ReactNode }) {
  const { status, user } = useAuth();
  if (status === "loading") return null;
  if (user?.role !== "admin") {
    return <Navigate to="/employees" replace />;
  }
  return <>{children}</>;
}
